import template from './suburban-building-status-land.jade';
import validation from '../../../services/validation';
import suburbanBuildingStatus from '../../../enums/suburban-building-status-land';

export default angular
    .module('cian.addForm.suburbanBuildingStatusLand', [])
    .directive('cianAfAboutObjectSuburbanBuildingStatusLand', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['deviceService', function (deviceService) {
            this.isMobile = deviceService.isMobile;
            this.suburbanBuildingStatusOptions = suburbanBuildingStatus;

            this.validation = validation(this.form, 'suburbanBuildingStatusLand', {
                required: 'Обязательное поле',
            });
        }],
        controllerAs: 'suburbanBuildingStatusLand',
        template,
    }))
    .name;
